import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
	AuthenticationService,
	LanguageService,
	LoaderService,
} from '@services/public';
import { map } from 'rxjs/operators';

const PATH = `pages.public.verify`;

@Component({
	selector: 'app-public-email-verify',
	templateUrl: './verify.component.html',
	styleUrls: ['./verify.component.scss'],
})
export class PublicEmailVerifyComponent implements OnInit {
	verified: boolean = false;
	pageLanguage: any;

	constructor(
		private _authenticationSvc: AuthenticationService,
		private _languageSvc: LanguageService,
		private _loaderSvc: LoaderService,
		private _route: ActivatedRoute,
	) {}

	ngOnInit(): void {
		this._languageSvc.get([PATH]).then((value) => {
			this.pageLanguage = value[PATH];
		});
		// Submit email verification code.
		const loader: unique symbol = Symbol();
		this._loaderSvc.addLoader(loader);
		this._authenticationSvc
			.verifyEmail(this._route.snapshot.paramMap.get('code'))
			.pipe(
				map((response: any) => {
					if (response.success) this.verified = true;
					this._loaderSvc.removeLoader(loader);
				}).bind(this),
			)
			.subscribe();
	}
}
